import React from 'react';
import { cx } from '../../utils/cx.js';

// Same pill palette as Globe Insights' Badge, plus red for destructive states.
const TONES = {
  blue: { wrap: 'text-[#3d5a8a] dark:text-blue-200 bg-[#e6f0ff] dark:bg-blue-900/40', dot: '#2f6df0' },
  green: { wrap: 'text-[#15784c] dark:text-green-200 bg-[#e2f5ea] dark:bg-green-900/40', dot: '#16a866' },
  amber: { wrap: 'text-[#8a6213] dark:text-amber-200 bg-[#fdf0d8] dark:bg-amber-900/40', dot: '#f5a623' },
  violet: { wrap: 'text-[#4a2fb0] dark:text-violet-200 bg-[#ece8fd] dark:bg-violet-900/40', dot: '#5b3df0' },
  slate: { wrap: 'text-[#3a4a63] dark:text-slate-200 bg-[#e8edf4] dark:bg-slate-700/50', dot: '#3a4a63' },
  red: { wrap: 'text-red-700 dark:text-red-200 bg-red-50 dark:bg-red-900/40', dot: '#dc2626' },
  gray: { wrap: 'text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-700/60', dot: '#9ca3af' },
};

const SIZES = {
  sm: 'px-2 py-0.5 text-[11px] gap-1',
  md: 'px-2.5 py-1 text-xs gap-1.5',
};

/** Pill / cartouche. `icon` takes an icon component; `dot` renders a leading colored dot. */
const Badge = ({ tone = 'gray', size = 'md', dot = false, icon: Icon = null, title, className = '', children }) => {
  const t = TONES[tone] || TONES.gray;
  return (
    <span
      title={title}
      className={cx('inline-flex items-center rounded-full font-medium whitespace-nowrap', SIZES[size] || SIZES.md, t.wrap, className)}
    >
      {dot && <span className="h-1.5 w-1.5 flex-shrink-0 rounded-full" style={{ background: t.dot }} aria-hidden />}
      {Icon && <Icon className="h-3 w-3 flex-shrink-0" aria-hidden />}
      {children}
    </span>
  );
};

export default Badge;
